import { render, staticRenderFns } from "./recChip.vue?vue&type=template&id=054428da&scoped=true&"
import script from "./recChip.vue?vue&type=script&lang=js&"
export * from "./recChip.vue?vue&type=script&lang=js&"
import style0 from "./recChip.vue?vue&type=style&index=0&id=054428da&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054428da",
  null
  
)

export default component.exports